

























import { Component, Prop, Ref, Vue } from 'vue-property-decorator';
import { MountingPortal } from 'portal-vue';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import scrollbarWidth from '@/utils/scrollbarWidth';
import Button from '@/components/Controls/Button';
import SvgIcon from '@/components/SvgIcon';

@Component({
    components: {
        MountingPortal,
        Button,
        SvgIcon,
    },
})
export default class Overlay extends Vue {
    /**
     *
     */
    @Ref()
    public readonly overlay!: HTMLElement;
    /**
     *
     */
    @Prop()
    public readonly active!: boolean;
    /**
     *
     */
    public onEscape(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            this.$emit('close');
        }
    }
    /**
     *
     */
    public onResize() {
        this.overlay.style.height = window.innerHeight + 'px';
    }
    /**
     *
     */
    public onTransitionBeforeEnter(el: HTMLElement) {
        document.body.style.paddingRight = scrollbarWidth() + 'px';
        document.body.style.overflow = 'hidden';
        this.$emit('before-enter', el);
    }
    /**
     *
     */
    public onTransitionEnter(el: HTMLElement) {
        disableBodyScroll(el);
        el.style.height = window.innerHeight + 'px';
        window.addEventListener('keyup', this.onEscape);
        window.addEventListener('resize', this.onResize);
        this.$emit('enter', el);
    }
    /**
     *
     */
    public onTransitionBeforeLeave(el: HTMLElement) {
        enableBodyScroll(el);
        window.removeEventListener('keyup', this.onEscape);
        window.removeEventListener('resize', this.onResize);
        this.$emit('before-leave', el);
    }
    /**
     *
     */
    public onTransitionAfterLeave(el: HTMLElement) {
        document.body.style.paddingRight = '';
        document.body.style.overflow = '';
        this.$emit('after-leave', el);
    }
}
